module.exports = __webpack_public_path__ + "img/img28.3cad39ce.png";